import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageIcon from "../../assets/images/language1.png";
import Logo from "../../assets/images/logo.jpg";
import support from "../../assets/images/support.png";
import { logPageView } from "../../utils/analytics";
import { useSelector } from "react-redux";
import { decryptJSON } from "../service/Encrtyption";
import ReactGA from 'react-ga4';
import { isOtpVerified } from "../../utils/otpSession";
import { parseScanData } from "../../utils/parseScanData";
import { teal } from "@mui/material/colors";

const Header = ({ isHide = false, hideHomeIcon = false }) => {
  const location = useLocation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const [surl, setsurl] = useState('');
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const scandataUrl = useSelector((state) => state?.scandataUrl);
  const parsedScan = parseScanData(scandataUrl);
  const isScanOtpVerified =
    parsedScan?.otpVerified === true ||
    parsedScan?.otpVerified === "true" ||
    parsedScan?.otpVerified === 1;


  useEffect(() => {
    const scanedData = sessionStorage.getItem('k');
    if (scanedData) {
      const surlderypted = decryptJSON(scanedData).replace(/"/g, '');
      setsurl(surlderypted);
    }
  }, []);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (language) => {

    ReactGA.event({
      category: 'Language Change',
      label: `Language changed to ${language}`,
      action: `Language changed to ${language}`,
    });

    i18n.changeLanguage(language);
    const currentPath = location.pathname.replace(`/${lang}`, '');
    const searchParams = location.search;
    console.log(searchParams + "searchParams");
    const newPath = `/${language}${currentPath}${searchParams}`;
    navigate(newPath);
    setIsOpen(false);
  };

  // const handleLanguageChange = (language) => {
  //   // debugger;
  //   i18n.changeLanguage(language);
  //   const currentPath = location.pathname.replace(`/${lang}`, '');
  //   if (user) {
  //     navigate(`/${language}${currentPath}`);
  //   } else {
  //     navigate(`/${language}${currentPath}?${decodeURIComponent(surl)}`);
  //   }
  //   setIsOpen(false);
  // };

  const handleNavigation = () => {
    // debugger; 
    if (user) {
      navigate(`/${lang}/home`);
    } else {
      const currentPath = `/login`;
      navigate(`/${lang}${currentPath}?${decodeURIComponent(surl)}`);
    }
  };

  const handleHomeClick = () => {
    if (user && (isOtpVerified() || isScanOtpVerified)) {
      navigate(`/${lang}/home`);
      return;
    }
    handleNavigation();
  };

  const showHomeButton =
    !hideHomeIcon &&
    Boolean(user) &&
    (isOtpVerified() || isScanOtpVerified);

  return (
    <div className="container-fluid p-0 fixed-header">
      <nav className="navbar navbar-light bg-gray">
        <span className="navbar-brand">
          <img
            src={Logo}
            className="logo"
            // onClick={handleNavigation}
            alt="Logo"
          />
        </span>

        {!isHide && (
          <div className="form-inline my-2 my-lg-0 ml-auto"> 
            
            <a href="tel:18601800186" className=" p-0 mr-2">
             <img src={support} alt="" className="supportIcon" />
            </a>

            {showHomeButton && (
              <button
                type="button"
                className="headerHomeBtn btn btn-link p-0 mr-2"
                onClick={handleHomeClick}
                style={{ fontSize: '1.5rem', lineHeight: 1 }}
              >
                <i className="fa fa-home" aria-hidden="true" />
              </button>
            )} 

            <div className="form-inline ml-auto">
              <div className="dropdown">
                <img
                  src={LanguageIcon}
                  className="languageIcon mr-2"
                  onClick={toggleDropdown}
                />
                {isOpen && (
                  <div className="dropdown-menu header_dropdown">
                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("mr")}
                    >
                      मराठी
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("hi")}
                    >
                      हिन्दी
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("kn")}
                    >
                      ಕನ್ನಡ
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("te")}
                    >
                      తెలుగు
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("pa")}
                    >
                      ਪੰਜਾਬੀ
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("gu")}
                    >
                      ગુજરાતી
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("en")}
                    >
                      English
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("ta")}
                    >
                      தமிழ்
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("bn")}
                    >
                      বাংলা
                    </button>

                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("or")}
                    >
                      ଓଡ଼ିଆ
                    </button>


                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Header;
